import styled from "styled-components";

export const StyledActionButton = styled.button`
    outline: 0;
    border: 0;
    width: 335px;
    height: 60px;
    border-radius: 7px;
    background: linear-gradient(180deg, ${(props: any) => props.colorOne} 0%, ${(props: any) => props.colorTwo} 100%);
    cursor: pointer;
    span {
        color: white;
        font-size: 16px;
        text-transform: initial;
    }
` as any;
